import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";
import { paramsFilter } from "@/services/OrderBankDarah";
import {
  RekapSerahTerimaFilter,
  RekapSerahTerimaResponse
} from "@/types/order_bank_darah";

function params(f: RekapSerahTerimaFilter) {
  return {
    ...paramsFilter(f),
    sampel: f.sampel || undefined,
    ttd: f.ttd || undefined
  };
}

async function list(f: RekapSerahTerimaFilter): Promise<RekapSerahTerimaResponse> {
  const res = await http
    .getDataParam("/laporan/bank-darah/rekap-serah-terima", { params: params(f) })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return res.data.data;
}

async function downloadExcel(f: RekapSerahTerimaFilter): Promise<void> {
  const res = await http
    .getDataParam("/laporan/bank-darah/rekap-serah-terima/excel", {
      params: params(f),
      responseType: "blob"
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  const url = URL.createObjectURL(
    new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
  );
  const a = document.createElement("a");
  a.href = url;
  a.download = `rekap-serah-terima-darah_${f.tgl_start}_${f.tgl_end}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default { list, downloadExcel };
